<template>
  <footer class="app-footer" role="contentinfo">
    <div class="app-footer__inner">
      <nav class="app-footer__nav" aria-label="Footer links">
        <router-link
          :to="{ name: 'PrivacyPolicy' }"
          data-track="footer_privacy"
          :data-track-props="JSON.stringify({ source: 'footer' })"
        >
          Privacy
        </router-link>

        <span class="sep" aria-hidden="true">•</span>

        <router-link
          :to="{ name: 'TermsOfService' }"
          data-track="footer_terms"
          :data-track-props="JSON.stringify({ source: 'footer' })"
        >
          Terms
        </router-link>

        <span class="sep" aria-hidden="true">•</span>

        <router-link
          :to="{ name: 'FairUsePolicy' }"
          data-track="footer_fair_use"
          :data-track-props="JSON.stringify({ source: 'footer' })"
        >
          Fair Use
        </router-link>

        <span class="sep" aria-hidden="true">•</span>

        <router-link
          :to="{ name: 'DisclaimerPage' }"
          data-track="footer_disclaimer"
          :data-track-props="JSON.stringify({ source: 'footer' })"
        >
          Disclaimer
        </router-link>
      </nav>

      <p class="app-footer__meta">
        © {{ year }} PathTracer • CoinStructive Inc.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return { year: new Date().getFullYear() };
  },
};
</script>

<style scoped>
/* Subtle, non-intrusive footer */
.app-footer {
  border-top: 1px solid rgba(229, 232, 236, 1);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: saturate(1.1) blur(6px);
}

.app-footer__inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0.85rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.app-footer__nav {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.95rem;
}

.app-footer__nav a {
  color: #0b63a9;
  text-decoration: none;
  padding: 0.25rem 0.2rem;
  border-radius: 8px;
}

.app-footer__nav a:hover {
  text-decoration: underline;
}

.sep {
  color: #9aa4b2;
}

.app-footer__meta {
  margin: 0;
  color: #6b7280;
  font-size: 0.9rem;
}
</style>
